module.exports = require('react/lib/ReactPerf');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-perf/index.js
 ** module id = 249
 ** module chunks = 2
 **/